export const WORDS = [
"ㄏㄨㄢㄍㄨ", // 環顧
"ㄕㄤㄒㄧㄢ", // 上限
"ㄖㄨㄐㄧㄥ", // 入境
"ㄩㄝㄊㄨㄢ", // 樂團
"ㄒㄧㄣㄕㄥ", // 心聲
"ㄈㄟㄒㄧㄥ", // 飛行
"ㄧㄡㄉㄧㄢ", // 優點
"ㄊㄠㄓㄨㄤ", // 套裝
"ㄌㄨㄍㄨㄛ", // 路過
"ㄗㄨㄛㄉㄠ", // 做到
"ㄐㄧㄠㄧㄝ", // 郊野
"ㄏㄨㄐㄧㄠ", // 呼叫
"ㄧㄡㄓㄩㄢ", // 幼稚園
"ㄏㄨㄛㄕㄠ", // 火燒
"ㄍㄨㄥㄍㄨ", // 鞏固
"ㄈㄢㄓㄨㄢ", // 反轉
"ㄓㄣㄙㄨㄛ", // 診所
"ㄒㄧㄍㄨㄢ", // 習慣
"ㄌㄧㄝㄖㄣ", // 獵人
"ㄕㄥㄑㄧㄢ", // 生前
"ㄓㄨㄍㄨㄢ", // 主管
"ㄔㄨㄥㄅㄞ", // 崇拜
"ㄐㄧㄒㄧㄝ", // 機械
"ㄐㄧㄚㄑㄧ", // 假期
"ㄘㄠㄎㄨㄥ", // 操控
"ㄏㄢㄐㄧㄢ", // 罕見
"ㄖㄣㄊㄨㄥ", // 認同
"ㄎㄜㄒㄧㄣ", // 可信
"ㄧㄠㄉㄧㄢ", // 要點
"ㄊㄡㄒㄧㄠ", // 偷笑
"ㄐㄧㄝㄖㄨ", // 介入
"ㄩㄣㄗㄨㄛ", // 運作
"ㄊㄧㄢㄕㄤ", // 天上
"ㄌㄠㄉㄨㄥ", // 勞動
"ㄕㄨㄣㄧㄢ", // 順眼
"ㄕㄡㄐㄧㄠ", // 手腳
"ㄧㄡㄒㄧㄣ", // 有心
"ㄗㄥㄐㄧㄚ", // 增加
"ㄆㄢㄉㄧㄥ", // 判定
"ㄉㄤㄒㄩㄢ", // 當選
"ㄕㄤㄒㄩㄝ", // 上學
"ㄊㄧㄊㄧㄝ", // 體貼
"ㄉㄠㄐㄧㄚ", // 到家
"ㄎㄨㄥㄒㄩ", // 空虛
"ㄇㄧㄣㄕㄥ", // 民生
"ㄈㄚㄒㄧㄢ", // 發現
"ㄉㄚㄍㄨㄣ", // 打滾
"ㄐㄧㄝㄌㄧ", // 竭力
"ㄖㄣㄒㄧㄣ", // 忍心
"ㄈㄚㄒㄧㄝ", // 發洩
"ㄕㄨㄉㄧㄢ", // 書店
"ㄘㄨㄛㄏㄜ", // 撮合
"ㄐㄧㄚㄖㄨ", // 假如
"ㄨㄤㄐㄧㄢ", // 望見
"ㄓㄨㄥㄉㄨ", // 中毒
"ㄒㄧㄣㄉㄧ", // 心地
"ㄐㄧㄆㄧㄠ", // 機票
"ㄧㄡㄑㄧㄥ", // 友情
"ㄎㄨㄞㄍㄢ", // 快感
"ㄓㄠㄆㄧㄢ", // 照片
"ㄑㄧㄤㄖㄣ", // 強人
"ㄇㄤㄉㄧㄢ", // 盲點
"ㄏㄨㄛㄓㄜ", // 或者
"ㄒㄧㄥㄑㄧ", // 興起
"ㄌㄧㄇㄧㄢ", // 裡面
"ㄏㄨㄤㄏㄜ", // 黃河
"ㄏㄨㄚㄩㄢ", // 花園
"ㄐㄧㄝㄎㄡ", // 藉口
"ㄒㄧㄠㄌㄩ", // 效率
"ㄒㄧㄤㄍㄜ", // 相隔
"ㄏㄨㄛㄕㄠ", // 火燒
"ㄌㄠㄍㄨㄥ", // 老公
"ㄑㄧㄥㄔㄨ", // 清楚
"ㄑㄧㄥㄍㄢ", // 情感
"ㄑㄩㄝㄈㄚ", // 缺乏
"ㄉㄨㄥㄧㄠ", // 動搖
"ㄍㄨㄛㄑㄩ", // 過去
"ㄗㄨㄛㄖㄣ", // 做人
"ㄍㄨㄥㄖㄣ", // 工人
"ㄧㄡㄌㄧㄥ", // 幽靈
"ㄎㄨㄥㄐㄩ", // 恐懼
"ㄨㄞㄅㄧㄠ", // 外表
"ㄍㄨㄤㄔㄤ", // 廣場
"ㄏㄞㄅㄧㄢ", // 海邊
"ㄨㄤㄌㄨㄛ", // 網絡
"ㄊㄜㄉㄧㄢ", // 特點
"ㄒㄧㄓㄨㄤ", // 西裝
"ㄈㄨㄐㄧㄣ", // 附近
"ㄓㄢㄍㄨㄛ", // 戰國
"ㄒㄧㄢㄕㄥ", // 先生
"ㄓㄨㄥㄈㄨ", // 中伏
"ㄊㄜㄒㄧㄥ", // 特性
"ㄍㄨㄥㄩㄢ", // 公園
"ㄊㄨㄥㄅㄢ", // 同班
"ㄩㄝㄌㄧㄤ", // 月亮
"ㄏㄨㄢㄌㄜ", // 歡樂
"ㄒㄧㄠㄔㄡ", // 小丑
"ㄒㄧㄣㄎㄨ", // 辛苦
"ㄔㄨㄥㄕㄤ", // 重傷
"ㄕㄠㄋㄧㄢ", // 少年
"ㄎㄜㄐㄧㄢ", // 可見
"ㄊㄧㄢㄏㄞ", // 填海
"ㄍㄨㄥㄐㄩ", // 工具
"ㄅㄠㄑㄧㄢ", // 抱歉
"ㄐㄧㄠㄕㄥ", // 叫聲
"ㄋㄢㄇㄧㄣ", // 難民
"ㄉㄚㄌㄨㄢ", // 大亂
"ㄐㄧㄥㄇㄛ", // 靜默
"ㄒㄧㄠㄈㄥ", // 校風
"ㄕㄤㄌㄧㄡ", // 上流
"ㄋㄧㄢㄉㄞ", // 年代
"ㄔㄥㄋㄨㄛ", // 承諾
"ㄧㄣㄑㄧㄥ", // 引擎
"ㄆㄧㄣㄆㄞ", // 品牌
"ㄍㄨㄥㄒㄧ", // 恭喜
"ㄊㄨㄓㄨㄥ", // 途中
"ㄒㄧㄣㄉㄧ", // 心底
"ㄑㄩㄣㄊㄧ", // 群體
"ㄑㄧㄣㄈㄢ", // 侵犯
"ㄏㄠㄒㄧㄤ", // 好像
"ㄉㄨㄢㄑㄧ", // 斷氣
"ㄒㄧㄒㄧㄣ", // 細心
"ㄅㄣㄒㄧㄥ", // 本性
"ㄗㄨㄟㄕㄠ", // 最少
"ㄐㄧㄢㄎㄤ", // 健康
"ㄅㄠㄓㄨㄥ", // 保重
"ㄧㄠㄎㄨㄥ", // 遙控
"ㄘㄞㄌㄧㄠ", // 材料
"ㄍㄜㄙㄨㄥ", // 歌頌
"ㄧㄣㄒㄧㄤ", // 音響
"ㄍㄨㄉㄧㄢ", // 古典
"ㄉㄧㄢㄉㄥ", // 電燈
"ㄧㄎㄡㄑㄧ", // 一口氣
"ㄐㄧㄠㄅㄨ", // 腳步
"ㄍㄨㄛㄧㄡ", // 國有
"ㄓㄥㄑㄩㄢ", // 政權
"ㄑㄩㄢㄔㄥ", // 全城
"ㄗㄐㄧㄖㄣ", // 自己人
"ㄍㄨㄛㄓㄣ", // 果真
"ㄉㄧㄥㄐㄩ", // 定居
"ㄧㄠㄐㄧㄣ", // 要緊
"ㄅㄠㄒㄧㄢ", // 保險
"ㄐㄧㄝㄕㄨ", // 結束
"ㄉㄧㄅㄧㄠ", // 地標
"ㄑㄧㄥㄒㄩ", // 情緒
"ㄒㄧㄚㄅㄢ", // 下班
"ㄘㄨㄌㄩㄝ", // 粗略
"ㄕㄜㄊㄨㄢ", // 社團
"ㄍㄣㄙㄨㄟ", // 跟隨
"ㄕㄣㄒㄧㄣ", // 身心
"ㄒㄧㄣㄔㄤ", // 心腸
"ㄅㄧㄠㄅㄤ", // 標榜
"ㄕㄣㄐㄧㄚ", // 身家
"ㄑㄩㄝㄖㄣ", // 確認
"ㄑㄧㄣㄑㄧ", // 親戚
"ㄍㄨㄛㄌㄩ", // 過濾
"ㄑㄧㄥㄌㄧ", // 情理
"ㄒㄧㄢㄏㄡ", // 先後
"ㄕㄢㄉㄧㄢ", // 閃電
"ㄐㄧㄉㄨㄥ", // 激動
"ㄓㄨㄢㄧㄢ", // 轉眼
"ㄉㄚㄒㄧㄥ", // 大型
"ㄏㄨㄛㄅㄧ", // 貨幣
"ㄇㄨㄑㄧㄢ", // 目前
"ㄊㄨㄥㄎㄨ", // 痛哭
"ㄕㄜㄧㄥㄕ", // 攝影師
"ㄍㄨㄛㄏㄡ", // 過後
"ㄒㄧㄤㄧㄥ", // 相應
"ㄎㄨㄞㄐㄧ", // 會計
"ㄏㄜㄒㄧㄝ", // 和諧
"ㄋㄧㄢㄕㄠ", // 年少
"ㄨㄞㄍㄨㄥ", // 外公
"ㄐㄧㄢㄒㄧ", // 見習
"ㄅㄧㄢㄇㄚ", // 編碼
"ㄌㄨㄣㄌㄧ", // 倫理
"ㄗㄞㄒㄧㄚ", // 在下
"ㄧㄣㄕㄨㄚ", // 印刷
"ㄗㄨㄟㄔㄨ", // 最初
"ㄅㄧㄢㄙㄜ", // 變色
"ㄉㄚㄉㄨㄛ", // 大多
"ㄔㄨㄉㄨㄥ", // 出動
"ㄉㄨㄥㄒㄧ", // 東西
"ㄕㄣㄉㄨㄢ", // 身段
"ㄒㄧㄥㄑㄧ", // 星期
"ㄊㄡㄊㄧㄠ", // 頭條
"ㄈㄨㄒㄧㄥ", // 復興
"ㄊㄧㄢㄑㄧ", // 天氣
"ㄘㄠㄗㄨㄛ", // 操作
"ㄆㄞㄉㄨㄟ", // 排隊
"ㄌㄥㄐㄧㄥ", // 冷靜
"ㄔㄥㄐㄧㄡ", // 成就
"ㄌㄧㄢㄒㄧ", // 聯繫
"ㄋㄢㄇㄧㄢ", // 難免
"ㄅㄠㄓㄨㄤ", // 包裝
"ㄑㄧㄥㄕㄢ", // 青山
"ㄕㄨㄌㄧㄤ", // 數量
"ㄌㄠㄇㄚㄗ", // 老媽子
"ㄐㄧㄝㄓㄜ", // 接著
"ㄒㄧㄏㄨㄢ", // 喜歡
"ㄒㄧㄥㄊㄞ", // 形態
"ㄉㄚㄐㄧㄚ", // 大家
"ㄒㄧㄇㄧㄝ", // 熄滅
"ㄨㄤㄒㄧㄤ", // 妄想
"ㄈㄟㄕㄨㄟ", // 廢水
"ㄕㄤㄌㄧㄤ", // 商量
"ㄉㄨㄍㄨㄛ", // 度過
"ㄅㄨㄒㄧㄝ", // 不屑
"ㄒㄧㄠㄉㄧ", // 小弟
"ㄊㄧㄝㄇㄚ", // 鐵馬
"ㄏㄠㄊㄧㄥ", // 好聽
"ㄍㄞㄒㄧㄝ", // 改寫
"ㄖㄨㄍㄨㄛ", // 如果
"ㄍㄢㄒㄧㄥ", // 感性
"ㄗㄨㄛㄓㄢ", // 作戰
"ㄒㄧㄤㄨㄤ", // 嚮往
"ㄓㄥㄑㄩㄝ", // 正確
"ㄒㄧㄥㄔㄥ", // 行程
"ㄍㄨㄏㄨㄛ", // 蠱惑
"ㄈㄤㄒㄩㄝ", // 放學
"ㄗㄨㄛㄑㄩ", // 作曲
"ㄔㄤㄍㄨㄥ", // 長工
"ㄎㄨㄒㄧㄠ", // 苦笑
"ㄐㄧㄏㄨㄟ", // 集會
"ㄉㄞㄐㄧㄚ", // 代價
"ㄅㄧㄠㄊㄧ", // 標題
"ㄐㄧㄥㄌㄧ", // 經理
"ㄐㄩㄒㄧㄢ", // 局限
"ㄒㄧㄚㄑㄧ", // 下氣
"ㄆㄞㄊㄨㄛ", // 拍拖
"ㄐㄧㄉㄨㄢ", // 極端
"ㄐㄧㄝㄈㄟ", // 劫匪
"ㄒㄧㄠㄏㄞ", // 小孩
"ㄐㄧㄥㄊㄡ", // 鏡頭
"ㄓㄨㄥㄖㄣ", // 眾人
"ㄒㄧㄤㄧㄡ", // 享有
"ㄖㄣㄐㄧㄢ", // 人間
"ㄖㄣㄒㄧㄥ", // 人性
"ㄍㄜㄒㄧㄥ", // 個性
"ㄇㄟㄐㄧㄝ", // 媒介
"ㄒㄧㄤㄨㄟ", // 香味
"ㄅㄞㄊㄨㄛ", // 擺脫
"ㄍㄨㄥㄋㄥ", // 功能
"ㄒㄧㄣㄩㄥ", // 信用
"ㄊㄨㄥㄍㄢ", // 同感
"ㄓㄨㄥㄔㄢ", // 中產
"ㄔㄨㄣㄕㄨ", // 純熟
"ㄎㄨㄣㄋㄢ", // 困難
"ㄒㄧㄚㄌㄞ", // 下來
"ㄨㄟㄒㄧㄝ", // 威脅
"ㄑㄧㄓㄨㄥ", // 其中
"ㄌㄧㄡㄩㄝ", // 六月
"ㄈㄚㄉㄧㄥ", // 法定
"ㄓㄥㄐㄧㄢ", // 證件
"ㄐㄧㄢㄔㄚ", // 檢查
"ㄘㄢㄒㄩㄢ", // 參選
"ㄋㄨㄥㄔㄤ", // 農場
"ㄧㄢㄍㄨㄤ", // 眼光
"ㄏㄠㄒㄧㄝ", // 好些
"ㄅㄨㄍㄨㄛ", // 不過
"ㄐㄧㄍㄨㄢ", // 機關
"ㄎㄨㄥㄉㄧ", // 空地
"ㄉㄨㄢㄎㄨ", // 短褲
"ㄓㄣㄗㄨㄛ", // 振作
"ㄙㄨㄛㄨㄟ", // 所謂
"ㄊㄧㄍㄨㄥ", // 提供
"ㄖㄜㄑㄧㄥ", // 熱情
"ㄩㄝㄅㄧㄥ", // 月餅
"ㄕㄡㄒㄧㄢ", // 首先
"ㄍㄨㄛㄋㄟ", // 國內
"ㄕㄣㄑㄧㄥ", // 申請
"ㄆㄧㄥㄕㄥ", // 平聲
"ㄉㄠㄑㄧㄢ", // 道歉
"ㄐㄧㄥㄧㄡ", // 經由
"ㄍㄨㄟㄌㄩ", // 規律
"ㄓㄨㄟㄕㄚ", // 追殺
"ㄈㄤㄒㄧㄢ", // 防線
"ㄊㄨㄥㄅㄨ", // 同步
"ㄧㄥㄒㄩㄥ", // 英雄
"ㄧㄡㄅㄧㄢ", // 右邊
"ㄗㄨㄐㄧㄢ", // 組件
"ㄋㄧㄥㄨㄤ", // 凝望
"ㄧㄡㄅㄧㄥ", // 有病
"ㄍㄢㄒㄧㄝ", // 感謝
"ㄈㄢㄘㄨㄛ", // 犯錯
"ㄓㄨㄤㄔㄜ", // 撞車
"ㄔㄚㄗㄨㄟ", // 插嘴
"ㄓㄨㄇㄧㄥ", // 著名
"ㄈㄚㄏㄨㄟ", // 發揮
"ㄧㄡㄧㄕㄡ", // 有一手
"ㄐㄧㄥㄘㄞ", // 精彩
"ㄏㄠㄏㄨㄚ", // 好話
"ㄈㄚㄍㄨㄢ", // 法官
"ㄗㄠㄋㄧㄢ", // 早年
"ㄐㄧㄡㄓㄥ", // 就正
"ㄉㄚㄌㄧㄤ", // 打量
"ㄍㄠㄒㄧㄚ", // 高下
"ㄒㄧㄢㄓㄨ", // 顯著
"ㄓㄨㄢㄊㄧ", // 專題
"ㄔㄨㄢㄨㄣ", // 傳聞
"ㄐㄧㄝㄉㄠ", // 街道
"ㄍㄞㄌㄧㄤ", // 改良
"ㄋㄩㄒㄧㄥ", // 女性
"ㄌㄧㄇㄧㄥ", // 黎明
"ㄗㄨㄛㄉㄚ", // 做大
"ㄒㄩㄣㄏㄠ", // 訊號
"ㄏㄤㄑㄧㄥ", // 行情
"ㄒㄩㄝㄩㄣ", // 學運
"ㄒㄧㄕㄨㄞ", // 蟋蟀
"ㄑㄩㄌㄧㄡ", // 去留
"ㄐㄧㄝㄕㄡ", // 接收
"ㄓㄨㄥㄅㄨ", // 中部
"ㄒㄧㄚㄨㄣ", // 下文
"ㄓㄨㄥㄌㄧ", // 中立
"ㄖㄣㄐㄧㄠ", // 任教
"ㄌㄡㄌㄨㄛ", // 嘍囉
"ㄉㄢㄆㄧㄥ", // 單憑
"ㄅㄞㄒㄧㄥ", // 百姓
"ㄒㄧㄠㄋㄩ", // 小女
"ㄊㄠㄏㄨㄚ", // 桃花
"ㄋㄧㄥㄐㄩ", // 凝聚
"ㄌㄠㄉㄨㄥ", // 勞動
"ㄓㄨㄣㄗㄜ", // 準則
"ㄔㄣㄗㄨㄟ", // 沉醉
"ㄕㄥㄅㄧㄥ", // 生病
"ㄕㄥㄇㄧㄥ", // 聲明
"ㄧㄕㄐㄧㄢ", // 一時間
"ㄊㄧㄠㄓㄢ", // 挑戰
"ㄔㄥㄍㄨㄥ", // 成功
"ㄏㄨㄞㄅㄠ", // 懷抱
"ㄋㄧㄡㄋㄞ", // 牛奶
"ㄏㄨㄟㄊㄡ", // 回頭
"ㄋㄠㄐㄧㄣ", // 腦筋
"ㄔㄨㄒㄧㄝ", // 出血
"ㄐㄧㄉㄨㄛ", // 幾多
"ㄉㄧㄌㄧㄢ", // 低廉
"ㄌㄧㄢㄒㄩ", // 連續
"ㄑㄩㄉㄨㄥ", // 驅動
"ㄩㄝㄑㄧㄡ", // 月球
"ㄏㄡㄌㄨㄥ", // 喉嚨
"ㄆㄧㄐㄩㄢ", // 疲倦
"ㄉㄧㄢㄩㄢ", // 店員
"ㄏㄨㄤㄏㄡ", // 皇后
"ㄓㄣㄐㄧㄝ", // 貞節
"ㄌㄧㄢㄗㄞ", // 連載
"ㄓㄨㄥㄗㄨ", // 種族
"ㄒㄧㄚㄅㄚ", // 下巴
"ㄋㄧㄢㄉㄧ", // 年底
"ㄒㄧㄠㄈㄨ", // 校服
"ㄓㄥㄑㄩㄢ", // 證券
"ㄗㄨㄑㄧㄡ", // 足球
"ㄕㄡㄉㄨㄢ", // 手段
"ㄊㄧㄥㄨㄣ", // 聽聞
"ㄐㄧㄠㄉㄨ", // 角度
"ㄌㄨㄥㄇㄣ", // 龍門
"ㄐㄧㄥㄖㄣ", // 驚人
"ㄊㄞㄋㄢㄕ", // 臺南市
"ㄍㄥㄒㄧㄣ", // 更新
"ㄋㄥㄌㄧㄤ", // 能量
"ㄩㄢㄒㄧㄥ", // 圓形
"ㄇㄧㄢㄙㄜ", // 面色
"ㄇㄧㄥㄩㄝ", // 明月
"ㄩㄥㄆㄧㄣ", // 用品
"ㄏㄨㄛㄔㄞ", // 火柴
"ㄊㄧㄠㄨㄣ", // 條文
"ㄩㄥㄐㄧㄡ", // 永久
"ㄏㄨㄌㄩㄝ", // 忽略
"ㄋㄩㄏㄞㄗ", // 女孩子
"ㄒㄧㄣㄑㄧ", // 新奇
"ㄖㄣㄒㄩㄢ", // 人選
"ㄉㄨㄧㄨㄦ", // 獨一無二
"ㄓㄢㄌㄩㄝ", // 戰略
"ㄐㄩㄝㄨㄤ", // 絕望
"ㄍㄨㄋㄧㄤ", // 姑娘
"ㄑㄧㄢㄓㄜ", // 前者
"ㄙㄨㄛㄗㄞ", // 所在
"ㄏㄨㄤㄧㄢ", // 謊言
"ㄆㄞㄇㄧㄥ", // 排名
"ㄐㄧㄚㄕㄣ", // 加深
"ㄍㄨㄛㄨㄤ", // 過往
"ㄆㄧㄥㄩㄢ", // 平原
"ㄇㄛㄍㄨㄟ", // 魔鬼
"ㄌㄟㄕㄨㄟ", // 淚水
"ㄎㄞㄏㄨㄟ", // 開會
"ㄧㄣㄌㄧㄠ", // 飲料
"ㄞㄗㄅㄧㄥ", // 愛滋病
"ㄧㄥㄍㄨㄤ", // 螢光
"ㄆㄛㄏㄨㄞ", // 破壞
"ㄙㄨㄐㄧㄠ", // 塑膠
"ㄏㄜㄉㄧㄥ", // 核定
"ㄌㄧㄥㄉㄠ", // 領導
"ㄊㄜㄑㄩㄢ", // 特權
"ㄒㄧㄒㄧㄠ", // 細小
"ㄈㄢㄗㄨㄟ", // 犯罪
"ㄓㄨㄓㄨㄥ", // 注重
"ㄊㄨㄥㄅㄠ", // 同胞
"ㄕㄤㄐㄧㄣ", // 上進
"ㄏㄨㄢㄅㄠ", // 環保
"ㄧㄡㄒㄧㄢ", // 優先
"ㄍㄨㄟㄗㄨ", // 貴族
"ㄉㄨㄥㄓㄨ", // 動植物
"ㄎㄨㄚㄎㄜ", // 夸克
"ㄅㄟㄇㄧㄢ", // 杯麵
"ㄏㄨㄤㄓㄤ", // 慌張
"ㄎㄜㄊㄧㄥ", // 客廳
"ㄧㄉㄚㄗㄠ", // 一大早
"ㄅㄢㄎㄨㄞ", // 板塊
"ㄅㄨㄊㄧㄥ", // 不停
"ㄏㄨㄟㄑㄩ", // 回去
"ㄋㄞㄒㄧㄥ", // 耐性
"ㄏㄞㄊㄨㄣ", // 海豚
"ㄑㄧㄆㄧㄢ", // 欺騙
"ㄐㄧㄣㄉㄨ", // 進度
"ㄎㄞㄏㄨㄚ", // 開花
"ㄅㄧㄢㄐㄧ", // 編輯
"ㄐㄧㄚㄍㄡ", // 架構
"ㄊㄢㄌㄨㄣ", // 談論
"ㄑㄩㄋㄧㄢ", // 去年
"ㄧㄥㄐㄧㄝ", // 迎接
"ㄆㄞㄆㄧㄢ", // 拍片
"ㄍㄤㄐㄧㄣ", // 鋼筋
"ㄌㄧㄕㄓㄤ", // 理事長
"ㄩㄝㄍㄨㄤ", // 月光
"ㄧㄡㄒㄧㄥ", // 有幸
"ㄉㄨㄥㄒㄧ", // 東西
"ㄘㄥㄇㄧㄢ", // 層面
"ㄓㄨㄚㄓㄨ", // 抓住
"ㄖㄥㄐㄧㄡ", // 仍舊
"ㄒㄧㄢㄇㄨ", // 羨慕
"ㄅㄤㄐㄧㄚ", // 綁架
"ㄐㄧㄧㄊㄧ", // 記憶體
"ㄒㄧㄥㄈㄨ", // 幸福
"ㄔㄨㄢㄓㄣ", // 傳真
"ㄔㄤㄙㄨㄛ", // 場所
"ㄉㄨㄛㄊㄡ", // 多頭
"ㄊㄨㄛㄧㄢ", // 拖延
"ㄅㄠㄍㄨㄟ", // 寶貴
"ㄧㄡㄒㄧㄥ", // 遊行
"ㄍㄨㄥㄌㄧ", // 功利
"ㄓㄨㄗㄨㄛ", // 著作
"ㄏㄡㄍㄨㄛ", // 後果
"ㄒㄧㄣㄌㄧ", // 心力
"ㄧㄢㄐㄧㄝ", // 眼界
"ㄩㄣㄉㄨㄥ", // 運動
"ㄓㄜㄒㄧㄝ", // 這些
"ㄅㄧㄉㄧㄥ", // 必定
"ㄏㄨㄐㄧㄠ", // 胡椒
"ㄆㄧㄢㄩㄢ", // 偏遠
"ㄗㄠㄐㄧㄡ", // 造就
"ㄙㄨㄟㄉㄠ", // 隧道
"ㄗㄨㄒㄧㄢ", // 祖先
"ㄅㄣㄑㄧㄢ", // 本錢
"ㄅㄥㄎㄨㄟ", // 崩潰
"ㄔㄡㄒㄧㄤ", // 抽象
"ㄧㄢㄑㄧㄡ", // 眼球
"ㄩㄣㄊㄨㄣ", // 雲吞
"ㄊㄧㄢㄇㄧ", // 甜蜜
"ㄇㄧㄣㄙㄨ", // 民俗
"ㄔㄨㄘㄨㄣ", // 儲存
"ㄊㄨㄟㄓㄢ", // 推展
"ㄊㄡㄊㄨㄥ", // 頭痛
"ㄧㄠㄆㄧㄣ", // 藥品
"ㄑㄧㄑㄧㄡ", // 祈求
"ㄉㄤㄇㄧㄢ", // 當面
"ㄕㄤㄉㄧㄢ", // 商店
"ㄆㄧㄥㄏㄥ", // 平衡
"ㄏㄨㄛㄆㄛ", // 活潑
"ㄍㄨㄛㄉㄨ", // 過度
"ㄊㄡㄗㄖㄣ", // 投資人
"ㄋㄨㄥㄧㄝ", // 農業
"ㄐㄩㄝㄉㄜ", // 覺得
"ㄒㄧㄣㄌㄤ", // 新郎
"ㄙㄜㄑㄧㄥ", // 色情
"ㄆㄧㄆㄧㄥ", // 批評
"ㄉㄧㄥㄌㄩ", // 定律
"ㄇㄧㄢㄈㄟ", // 免費
"ㄇㄨㄅㄧㄠ", // 目標
"ㄌㄧㄉㄨㄛ", // 利多
"ㄙㄢㄍㄨㄛ", // 三國
"ㄒㄩㄢㄅㄨ", // 宣布
"ㄋㄧㄥㄎㄜ", // 寧可
"ㄓㄨㄢㄌㄧ", // 專利
"ㄏㄨㄟㄈㄨ", // 回復
"ㄐㄧㄢㄌㄧ", // 建立
"ㄧㄝㄋㄧㄠ", // 野鳥
"ㄏㄨㄛㄔㄜ", // 貨車
"ㄅㄚㄍㄨㄥ", // 罷工
"ㄏㄡㄧㄓㄥ", // 後遺症
"ㄧㄚㄑㄧㄢ", // 牙籤
"ㄒㄧㄢㄑㄧ", // 嫌棄
"ㄇㄧㄣㄧㄠ", // 民謠
"ㄏㄜㄗㄨㄛ", // 合作
"ㄍㄜㄐㄧㄢ", // 隔間
"ㄑㄧㄣㄖㄨ", // 侵入
"ㄌㄟㄒㄧㄥ", // 類型
"ㄕㄜㄉㄧㄥ", // 設定
"ㄍㄠㄎㄨㄥ", // 高空
"ㄓㄨㄢㄌㄢ", // 專欄
"ㄉㄧㄇㄧㄢ", // 地面
"ㄉㄤㄓㄨㄥ", // 當中
"ㄔㄨㄢㄉㄧ", // 傳遞
"ㄉㄚㄐㄧㄢ", // 打尖
"ㄅㄞㄋㄧㄢ", // 拜年
"ㄗㄥㄊㄧㄢ", // 增添
"ㄍㄨㄤㄅㄛ", // 廣播
"ㄉㄤㄒㄧㄚ", // 當下
"ㄕㄤㄎㄨㄥ", // 上空
"ㄍㄨㄛㄖㄣ", // 過人
"ㄒㄩㄢㄧㄤ", // 宣揚
"ㄏㄨㄟㄓㄤ", // 會長
"ㄌㄠㄋㄧㄢ", // 老年
"ㄒㄧㄣㄎㄡ", // 心口
"ㄆㄧㄥㄈㄢ", // 平凡
"ㄍㄤㄑㄧㄣ", // 鋼琴
"ㄌㄩㄒㄧㄥ", // 旅行
"ㄋㄨㄛㄈㄨ", // 懦夫
"ㄈㄣㄉㄧㄢ", // 分店
"ㄧㄡㄎㄨㄥ", // 有空
"ㄒㄧㄠㄒㄧ", // 消息
"ㄊㄨㄥㄕㄥ", // 同聲
"ㄑㄧㄤㄧㄥ", // 強硬
"ㄏㄨㄟㄧㄥ", // 回應
"ㄊㄡㄍㄨㄛ", // 透過
"ㄋㄢㄍㄨㄛ", // 難過
"ㄇㄞㄌㄨㄛ", // 脈絡
"ㄔㄨㄥㄇㄢ", // 充滿
"ㄇㄧㄣㄗㄨ", // 民族
"ㄑㄧㄣㄌㄠ", // 勤勞
"ㄅㄧㄠㄧㄢ", // 表演
"ㄏㄞㄐㄩㄣ", // 海軍
"ㄍㄨㄑㄧㄝ", // 姑且
"ㄨㄞㄐㄧㄝ", // 外界
"ㄊㄧㄏㄨㄟ", // 體會
"ㄅㄧㄢㄐㄩ", // 編劇
"ㄒㄩㄢㄗㄜ", // 選擇
"ㄍㄡㄊㄨㄥ", // 溝通
"ㄒㄧㄠㄍㄨ", // 小姑
"ㄍㄞㄐㄧㄢ", // 改建
"ㄒㄧㄠㄗㄨ", // 小組
"ㄒㄧㄢㄔㄨ", // 顯出
"ㄌㄧㄤㄌㄠ", // 兩老
"ㄋㄧㄠㄧㄝ", // 尿液
"ㄐㄧㄥㄌㄧ", // 經歷
"ㄎㄞㄒㄧㄣ", // 開心
"ㄗㄨㄍㄨㄛ", // 祖國
"ㄐㄧㄥㄔㄚ", // 警察
"ㄔㄥㄑㄩㄣ", // 成群
"ㄉㄨㄟㄕㄤ", // 對上
"ㄐㄧㄣㄊㄡ", // 盡頭
"ㄌㄧㄥㄍㄢ", // 靈感
"ㄏㄡㄇㄧㄢ", // 後面
"ㄒㄩㄝㄈㄣ", // 學分
"ㄔㄠㄊㄧㄥ", // 朝廷
"ㄐㄧㄠㄊㄚ", // 腳踏
"ㄐㄩㄉㄨㄥ", // 舉動
"ㄍㄞㄍㄨㄚ", // 概括
"ㄌㄢㄊㄧㄢ", // 藍天
"ㄍㄨㄛㄌㄞ", // 過來
"ㄆㄞㄌㄧㄝ", // 排列
"ㄌㄧㄌㄧㄤ", // 力量
"ㄉㄢㄉㄧㄠ", // 單調
"ㄔㄤㄋㄧㄢ", // 長年
"ㄅㄞㄊㄨㄛ", // 拜託
"ㄏㄡㄋㄧㄠ", // 候鳥
"ㄆㄞㄑㄧㄡ", // 排球
"ㄉㄚㄌㄧㄕ", // 大理石
"ㄍㄨㄛㄍㄜ", // 國歌
"ㄒㄧㄠㄔㄨ", // 消除
"ㄎㄜㄍㄨㄟ", // 可貴
"ㄊㄜㄉㄧㄥ", // 特定
"ㄩㄢㄍㄨㄥ", // 員工
"ㄌㄧㄥㄧㄤ", // 領養
"ㄍㄜㄊㄧㄢ", // 隔天
"ㄆㄧㄥㄈㄣ", // 評分
"ㄒㄧㄣㄐㄧ", // 心急
"ㄐㄧㄥㄧㄚ", // 驚訝
"ㄏㄨㄢㄖㄠ", // 環繞
"ㄌㄧㄤㄔㄢ", // 量產
"ㄍㄨㄢㄔㄚ", // 觀察
"ㄖㄣㄇㄧㄥ", // 人命
"ㄐㄧㄚㄖㄜ", // 加熱
"ㄍㄢㄘㄨㄟ", // 乾脆
"ㄅㄧㄉㄨㄟ", // 比對
"ㄌㄧㄡㄔㄥ", // 流程
"ㄅㄨㄌㄧㄡ", // 不留
"ㄨㄢㄐㄧㄚ", // 玩家
"ㄧㄢㄒㄧㄥ", // 言行
"ㄌㄧㄏㄨㄣ", // 離婚
"ㄙㄨㄛㄉㄜ", // 所得
"ㄉㄨㄛㄈㄤ", // 多方
"ㄨㄢㄏㄨㄟ", // 晚會
"ㄅㄢㄓㄨㄛ", // 辦桌
"ㄐㄩㄑㄧㄥ", // 劇情
"ㄏㄨㄣㄕㄚ", // 婚紗
"ㄨㄞㄍㄨㄛ", // 外國
"ㄒㄩㄥㄉㄧ", // 兄弟
"ㄊㄨㄥㄏㄠ", // 同好
"ㄔㄨㄆㄧㄣ", // 出品
"ㄕㄣㄑㄧㄥ", // 神情
"ㄩㄢㄉㄨㄥ", // 遠東
"ㄈㄚㄉㄨㄥ", // 發動
"ㄐㄧㄚㄔㄜ", // 駕車
"ㄍㄠㄓㄨㄥ", // 高中
"ㄊㄧㄠㄊㄧ", // 挑剔
"ㄏㄤㄒㄧㄢ", // 航線
"ㄒㄧㄥㄧㄝ", // 行業
"ㄉㄨㄟㄅㄧ", // 對比
"ㄒㄩㄥㄉㄢ", // 熊膽
"ㄒㄧㄡㄨㄟ", // 臭味
"ㄨㄣㄐㄧㄥ", // 文靜
"ㄔㄥㄒㄧㄠ", // 成效
"ㄅㄨㄐㄧㄣ", // 不盡
"ㄑㄩㄢㄆㄢ", // 全盤
"ㄓㄓㄥㄉㄤ", // 執政黨
"ㄩㄣㄙㄨㄢ", // 運算
"ㄕㄢㄌㄧㄣ", // 山林
"ㄑㄧㄢㄕㄜ", // 牽涉
"ㄌㄧㄥㄔㄣ", // 凌晨
"ㄒㄧㄚㄕㄡ", // 下手
"ㄩㄥㄕㄨㄟ", // 用水
"ㄏㄨㄢㄏㄨ", // 歡呼
"ㄏㄞㄊㄨㄥ", // 孩童
"ㄌㄨㄛㄏㄡ", // 落後
"ㄐㄧㄚㄍㄜ", // 價格
"ㄆㄧㄥㄩㄥ", // 平庸
"ㄌㄧㄝㄔㄜ", // 列車
"ㄕㄥㄐㄧㄤ", // 升降
"ㄊㄞㄅㄟㄕ", // 臺北市
"ㄔㄥㄑㄧㄥ", // 澄清
"ㄇㄧㄝㄨㄤ", // 滅亡
"ㄨㄟㄒㄧㄡ", // 維修
"ㄊㄠㄌㄨㄣ", // 討論
"ㄓㄨㄣㄅㄟ", // 準備
"ㄒㄧㄠㄇㄟ", // 小妹
"ㄏㄨㄉㄧㄝ", // 蝴蝶
"ㄕㄡㄒㄩㄣ", // 受訓
"ㄏㄢㄍㄨㄛ", // 韓國
"ㄎㄨㄚㄩㄝ", // 跨越
"ㄐㄧㄝㄙㄢ", // 解散
"ㄨㄣㄏㄨㄚ", // 文化
"ㄙㄨㄛㄓㄤ", // 所長
"ㄓㄜㄒㄩㄝ", // 哲學
"ㄍㄨㄥㄅㄨ", // 公布
"ㄔㄨㄥㄕㄤ", // 重傷
"ㄔㄨㄢㄩㄝ", // 穿越
"ㄅㄨㄐㄩㄝ", // 不絕
"ㄘㄠㄆㄧㄥ", // 草坪
"ㄉㄨㄥㄩㄢ", // 動員
"ㄍㄨㄛㄊㄨ", // 國土
"ㄋㄢㄍㄨㄞ", // 難怪
"ㄏㄨㄟㄍㄨ", // 回顧
"ㄇㄧㄢㄐㄧ", // 面積
"ㄎㄚㄆㄧㄢ", // 卡片
"ㄌㄧㄢㄇㄤ", // 連忙
"ㄉㄨㄟㄉㄞ", // 對待
"ㄧㄡㄑㄧㄢ", // 有錢
"ㄗㄨㄥㄘㄞ", // 總裁
"ㄓㄨㄢㄓㄨ", // 專注
"ㄏㄨㄥㄔㄚ", // 紅茶
"ㄍㄞㄅㄧㄢ", // 改變
"ㄊㄨㄕㄨㄕ", // 圖書室
"ㄒㄩㄢㄌㄩ", // 旋律
"ㄕㄨㄣㄉㄞ", // 順帶
"ㄍㄡㄒㄧㄤ", // 構想
"ㄉㄨㄥㄌㄧ", // 動力
"ㄑㄩㄢㄌㄧ", // 權力
"ㄐㄧㄥㄙㄜ", // 景色
"ㄕㄨㄌㄨㄛ", // 數落
"ㄍㄨㄥㄕㄣ", // 公審
"ㄔㄨㄥㄊㄨ", // 衝突
"ㄊㄜㄅㄧㄝ", // 特別
"ㄋㄧㄡㄖㄡ", // 牛肉
"ㄊㄧㄢㄏㄡ", // 天后
"ㄍㄨㄢㄈㄤ", // 官方
"ㄕㄨㄤㄈㄤ", // 雙方
"ㄓㄨㄛㄕㄨ", // 著數
"ㄏㄞㄕㄨㄟ", // 海水
"ㄒㄧㄣㄊㄥ", // 心疼
"ㄑㄧㄥㄓㄠ", // 清朝
"ㄉㄧㄝㄆㄛ", // 跌破
"ㄅㄨㄆㄧㄥ", // 不平
"ㄑㄧㄢㄏㄡ", // 前後
"ㄅㄧㄝㄕㄨ", // 別墅
"ㄏㄨㄟㄈㄨ", // 恢復
"ㄅㄛㄉㄨㄛ", // 剝奪
"ㄇㄧㄢㄇㄠ", // 面貌
"ㄈㄨㄇㄧㄢ", // 負面
"ㄏㄠㄆㄧㄥ", // 好評
"ㄍㄨㄛㄩㄝ", // 國樂
"ㄔㄨㄍㄨㄛ", // 出國
"ㄍㄤㄊㄧㄝ", // 鋼鐵
"ㄔㄤㄐㄧㄥ", // 場景
"ㄍㄜㄇㄧㄥ", // 革命
"ㄐㄧㄚㄗㄚ", // 夾雜
"ㄔㄨㄥㄈㄣ", // 充分
"ㄔㄠㄗㄨㄛ", // 炒作
"ㄌㄧㄥㄨㄞ", // 另外
"ㄔㄢㄌㄧㄤ", // 產量
"ㄐㄧㄤㄧㄥ", // 僵硬
"ㄕㄤㄑㄧㄝ", // 尚且
"ㄕㄨㄛㄈㄚ", // 說法
"ㄅㄚㄑㄩㄢ", // 霸權
"ㄑㄧㄌㄧㄥ", // 欺凌
"ㄑㄩㄢㄅㄨ", // 全部
"ㄅㄠㄎㄨㄛ", // 包括
"ㄏㄨㄟㄌㄞ", // 回來
"ㄉㄜㄗㄨㄟ", // 得罪
"ㄐㄧㄝㄊㄡ", // 街頭
"ㄐㄧㄥㄧㄢ", // 經驗
"ㄈㄤㄔㄥㄕ", // 方程式
"ㄨㄟㄏㄨㄣ", // 未婚
"ㄉㄧㄆㄧㄢ", // 底片
"ㄧㄡㄒㄧㄢ", // 有限
"ㄕㄢㄍㄨㄤ", // 閃光
"ㄐㄩㄝㄅㄨ", // 絕不
"ㄅㄨㄔㄨㄥ", // 補充
"ㄌㄞㄅㄧㄣ", // 來賓
"ㄕㄨㄟㄈㄨ", // 說服
"ㄇㄟㄍㄨㄟ", // 玫瑰
"ㄕㄨㄤㄕㄡ", // 雙手
"ㄓㄨㄟㄍㄢ", // 追趕
"ㄍㄨㄥㄓㄞ", // 公債
"ㄌㄧㄢㄙㄞ", // 聯賽
"ㄉㄞㄎㄨㄢ", // 貸款
"ㄍㄨㄆㄧㄠ", // 股票
"ㄍㄨㄛㄕㄣ", // 過身
"ㄌㄧㄡㄅㄤ", // 劉邦
"ㄏㄠㄒㄧㄠ", // 好笑
"ㄏㄠㄊㄧㄢ", // 好天
"ㄉㄧㄢㄅㄛ", // 電波
"ㄏㄟㄉㄨㄥ", // 黑洞
"ㄐㄩㄢㄗㄥ", // 捐贈
"ㄕㄢㄕㄨㄛ", // 閃爍
"ㄌㄧㄝㄧㄣ", // 列印
"ㄏㄞㄒㄧㄡ", // 害羞
"ㄉㄚㄍㄨㄥ", // 打工
"ㄒㄧㄚㄓㄡ", // 下晝
"ㄑㄩㄢㄌㄧ", // 全力
"ㄧㄣㄐㄧㄡ", // 飲酒
"ㄍㄢㄐㄩㄝ", // 感覺
"ㄓㄤㄊㄧㄥ", // 漲停
"ㄨㄢㄨㄧㄕ", // 萬無一失
"ㄐㄧㄣㄕㄥ", // 今生
"ㄕㄦㄓㄔㄤ", // 十二指腸
"ㄉㄢㄐㄧㄤ", // 淡江
"ㄓㄨㄢㄩㄥ", // 專用
"ㄌㄨㄒㄧㄢ", // 路線
"ㄉㄤㄅㄧㄥ", // 當兵
"ㄉㄨㄐㄧㄥ", // 讀經
"ㄈㄚㄐㄩㄝ", // 發掘
"ㄍㄨㄥㄨㄣ", // 公文
"ㄊㄧㄢㄓㄣ", // 天真
"ㄨㄣㄒㄩㄝ", // 文學
"ㄈㄚㄗㄨㄛ", // 發作
"ㄑㄧㄢㄋㄥ", // 潛能
"ㄅㄛㄖㄨㄛ", // 薄弱
"ㄏㄨㄣㄧㄠ", // 混淆
"ㄓㄥㄐㄧㄥ", // 正經
"ㄑㄧㄢㄊㄧ", // 前提
"ㄧㄡㄆㄧㄠ", // 郵票
"ㄓㄨㄢㄔㄤ", // 專長
"ㄘㄥㄐㄧㄥ", // 曾經
"ㄇㄧㄑㄧㄝ", // 密切
"ㄗㄨㄛㄓㄜ", // 作者
"ㄍㄨㄟㄌㄟ", // 歸類
"ㄐㄧㄥㄍㄠ", // 警告
"ㄘㄨㄥㄇㄤ", // 匆忙
"ㄧㄣㄍㄨㄛ", // 因果
"ㄍㄥㄐㄧㄚ", // 更加
"ㄨㄢㄏㄨㄟ", // 挽回
"ㄐㄧㄤㄌㄞ", // 將來
"ㄈㄚㄎㄨㄤ", // 發狂
"ㄧㄒㄧㄚㄗ", // 一下子
"ㄉㄨㄥㄅㄟ", // 東北
"ㄍㄨㄟㄐㄩ", // 規矩
"ㄙㄢㄐㄧㄠ", // 三角
"ㄊㄨㄥㄉㄥ", // 同等
"ㄅㄢㄑㄧㄠ", // 板橋
"ㄐㄧㄣㄓㄠ", // 今朝
"ㄅㄧㄢㄍㄜ", // 變革
"ㄎㄢㄐㄧㄢ", // 看見
"ㄐㄧㄑㄧㄥ", // 激情
"ㄐㄧㄥㄊㄢ", // 驚嘆
"ㄧㄢㄓㄨㄥ", // 嚴重
"ㄉㄨㄟㄧㄥ", // 對應
"ㄕㄥㄒㄧㄤ", // 聲響
"ㄋㄨㄥㄧㄠ", // 農藥
"ㄈㄤㄒㄧㄚ", // 放下
"ㄅㄢㄙㄨㄟ", // 伴隨
"ㄔㄜㄌㄧㄤ", // 車輛
"ㄌㄞㄏㄨㄟ", // 來回
"ㄍㄨㄛㄊㄡ", // 過頭
"ㄑㄧㄥㄅㄞ", // 清白
"ㄉㄨㄥㄐㄧ", // 動機
"ㄓㄥㄇㄧㄢ", // 正面
"ㄏㄨㄌㄨㄢ", // 胡亂
"ㄍㄜㄓㄨㄥ", // 各種
"ㄒㄩㄉㄨㄛ", // 許多
"ㄖㄡㄖㄨㄢ", // 柔軟
"ㄖㄨㄑㄧㄣ", // 入侵
"ㄑㄧㄚㄉㄤ", // 恰當
"ㄊㄨㄥㄙㄨ", // 通俗
"ㄊㄨㄟㄔㄨ", // 退出
"ㄉㄨㄥㄊㄞ", // 動態
"ㄎㄨㄥㄆㄚ", // 恐怕
"ㄧㄡㄓㄨㄥ", // 有種
"ㄩㄢㄌㄧㄤ", // 原諒
"ㄐㄧㄢㄕㄠ", // 減少
"ㄏㄤㄑㄩㄢ", // 航權
"ㄋㄩㄑㄩㄢ", // 女權
"ㄊㄧㄢㄘㄞ", // 天才
"ㄨㄌㄧㄍㄢ", // 無力感
"ㄎㄢㄅㄧㄥ", // 看病
"ㄓㄨㄥㄨㄣ", // 中文
"ㄎㄨㄟㄧㄤ", // 潰瘍
"ㄔㄚㄏㄨㄛ", // 查獲
"ㄏㄞㄍㄨㄢ", // 海關
"ㄅㄢㄕㄔㄨ", // 辦事處
"ㄧㄢㄐㄧㄤ", // 演講
"ㄨㄧㄓㄨㄥ", // 無意中
"ㄉㄧㄑㄧㄡ", // 地球
"ㄔㄠㄍㄨㄛ", // 超過
"ㄋㄟㄐㄧㄡ", // 內疚
"ㄆㄢㄉㄨㄢ", // 判斷
"ㄓㄥㄇㄧㄥ", // 正名
"ㄒㄩㄝㄨㄣ", // 學問
"ㄆㄠㄒㄧㄠ", // 咆哮
"ㄊㄨㄒㄧㄥ", // 土星
"ㄅㄢㄍㄨㄥ", // 辦公
"ㄋㄨㄥㄌㄧ", // 農曆
"ㄏㄤㄌㄧㄝ", // 行列
"ㄏㄨㄒㄧㄤ", // 互相
"ㄩㄣㄓㄨㄢ", // 運轉
"ㄓㄗㄠㄧㄝ", // 製造業
"ㄨㄟㄉㄧㄥ", // 未定
"ㄈㄥㄍㄨㄤ", // 風光
"ㄅㄛㄨㄩㄢ", // 博物院
"ㄕㄡㄆㄧㄢ", // 受騙
"ㄊㄧㄢㄊㄤ", // 天堂
"ㄏㄨㄤㄖㄢ", // 恍然
"ㄙㄨㄛㄕㄨ", // 所屬
"ㄏㄨㄤㄇㄤ", // 慌忙
"ㄑㄧㄚㄏㄠ", // 恰好
"ㄕㄡㄑㄧㄤ", // 手槍
"ㄊㄡㄆㄧㄠ", // 投票
"ㄒㄩㄝㄓㄜ", // 學者
"ㄉㄚㄗㄨㄛ", // 大作
"ㄨㄢㄑㄩㄢ", // 完全
"ㄉㄨㄟㄓㄠ", // 對照
"ㄍㄨㄥㄎㄜ", // 功課
"ㄗㄥㄑㄧㄤ", // 增強
"ㄎㄨㄛㄓㄤ", // 擴張
"ㄍㄨㄥㄖㄣ", // 公認
"ㄈㄣㄇㄧㄥ", // 分明
"ㄍㄨㄢㄘㄞ", // 棺材
"ㄍㄠㄍㄨㄢ", // 高官
"ㄒㄧㄤㄌㄞ", // 向來
"ㄍㄨㄢㄎㄚ", // 關卡
"ㄇㄧㄣㄧㄥ", // 民營
"ㄓㄨㄟㄨㄣ", // 追問
"ㄉㄢㄅㄞㄓ", // 蛋白質
"ㄓㄥㄉㄨㄣ", // 整頓
"ㄐㄧㄢㄆㄢ", // 鍵盤
"ㄑㄩㄢㄕㄣ", // 全身
"ㄒㄧㄡㄈㄚ", // 秀髮
"ㄋㄟㄒㄧㄣ", // 內心
"ㄒㄩㄑㄧㄡ", // 需求
"ㄍㄜㄒㄧㄣ", // 革新
"ㄒㄧㄚㄑㄩ", // 下去
"ㄎㄨㄞㄌㄜ", // 快樂
"ㄕㄨㄛㄌㄞ", // 說來
"ㄇㄣㄆㄧㄠ", // 門票
"ㄍㄞㄐㄧㄣ", // 改進
"ㄘㄜㄙㄨㄛ", // 廁所
"ㄐㄧㄤㄋㄢ", // 江南
"ㄒㄩㄝㄎㄜ", // 學科
"ㄑㄧㄐㄧㄢ", // 期間
"ㄏㄨㄢㄇㄢ", // 緩慢
"ㄍㄨㄛㄐㄧ", // 國籍
"ㄨㄣㄉㄧㄥ", // 穩定
"ㄊㄥㄊㄨㄥ", // 疼痛
"ㄧㄤㄍㄨㄤ", // 陽光
"ㄏㄠㄍㄨㄛ", // 好過
"ㄗㄥㄉㄨㄛ", // 增多
"ㄖㄣㄑㄩㄣ", // 人群
"ㄐㄧㄥㄑㄧ", // 經期
"ㄊㄞㄍㄨㄛ", // 太過
"ㄌㄧㄥㄊㄨ", // 領土
"ㄐㄧㄣㄓㄢ", // 進展
"ㄗㄨㄛㄨㄢ", // 昨晚
"ㄈㄤㄙㄨㄥ", // 放鬆
"ㄓㄢㄊㄧㄥ", // 暫停
"ㄅㄨㄇㄧㄢ", // 不免
"ㄧㄝㄐㄧㄝ", // 業界
"ㄕㄨㄐㄧㄚ", // 書架
"ㄐㄧㄤㄉㄠ", // 講道
"ㄇㄧㄢㄇㄨ", // 面目
"ㄇㄧㄢㄧㄢ", // 綿延
"ㄧㄣㄑㄧㄝ", // 殷切
"ㄕㄡㄐㄧㄚ", // 售價
"ㄈㄚㄒㄧㄥ", // 髮型
"ㄅㄧㄠㄉㄚ", // 表達
"ㄌㄧㄢㄎㄠ", // 聯考
"ㄉㄧㄠㄔㄚ", // 調查
"ㄑㄧㄍㄨㄞ", // 奇怪
"ㄉㄚㄏㄨㄚ", // 大話
"ㄨㄣㄒㄧㄢ", // 文獻
"ㄩㄢㄌㄧㄠ", // 原料
"ㄔㄜㄒㄧㄤ", // 車廂
"ㄗㄧㄢㄗㄩ", // 自言自語
"ㄍㄨㄢㄏㄨ", // 關乎
"ㄆㄛㄌㄧㄝ", // 破裂
"ㄑㄧㄤㄉㄠ", // 強盜
"ㄆㄧㄢㄔㄚ", // 偏差
"ㄐㄧㄤㄕㄨ", // 講述
"ㄔㄜㄏㄨㄛ", // 車禍
"ㄒㄧㄥㄨㄣ", // 行文
"ㄇㄥㄐㄩㄣ", // 盟軍
"ㄑㄧㄠㄏㄜ", // 巧合
"ㄐㄧㄚㄔㄤ", // 家常
"ㄐㄧㄡㄅㄚ", // 酒吧
"ㄍㄨㄤㄈㄨ", // 光復
"ㄗㄞㄕㄨㄛ", // 再說
"ㄑㄧㄥㄔㄨ", // 清除
"ㄔㄨㄥㄉㄤ", // 充當
"ㄐㄧㄠㄧㄡ", // 交友
"ㄖㄜㄌㄧㄝ", // 熱烈
"ㄇㄡㄒㄧㄝ", // 某些
"ㄇㄧㄢㄅㄠ", // 麵包
"ㄕㄜㄐㄧㄠ", // 社交
"ㄕㄞㄒㄩㄢ", // 篩選
"ㄘㄨㄒㄧㄠ", // 促銷
"ㄒㄧㄤㄊㄨ", // 鄉土
"ㄐㄧㄡㄈㄢ", // 就範
"ㄌㄨㄛㄉㄢ", // 落單
"ㄐㄧㄠㄊㄨ", // 教徒
"ㄌㄜㄙㄨㄛ", // 勒索
"ㄓㄨㄥㄊㄡ", // 鐘頭
"ㄆㄧㄥㄗㄜ", // 平仄
"ㄖㄨㄛㄍㄢ", // 若干
"ㄆㄣㄑㄩㄢ", // 噴泉
"ㄙㄨㄣㄏㄞ", // 損害
"ㄋㄧㄌㄧㄡ", // 逆流
"ㄐㄩㄍㄨㄥ", // 鞠躬
"ㄒㄩㄝㄌㄧ", // 學歷
"ㄧㄡㄏㄨㄛ", // 誘惑
"ㄍㄨㄤㄇㄤ", // 光芒
"ㄍㄠㄊㄧㄝ", // 高鐵
"ㄧㄚㄍㄨㄢ", // 牙關
"ㄐㄧㄝㄍㄡ", // 結構
"ㄌㄧㄠㄌㄧ", // 料理
"ㄔㄥㄐㄧㄠ", // 成交
"ㄎㄣㄉㄧㄥ", // 肯定
"ㄒㄩㄝㄍㄠ", // 雪糕
"ㄊㄧㄥㄔㄜ", // 停車
"ㄉㄧㄢㄋㄠ", // 電腦
"ㄐㄧㄢㄓㄥ", // 見證
"ㄕㄨㄣㄕㄡ", // 順手
"ㄏㄜㄒㄧㄣ", // 核心
"ㄕㄢㄕㄨㄟ", // 山水
"ㄉㄤㄐㄧㄣ", // 當今
"ㄏㄥㄌㄧㄤ", // 衡量
"ㄔㄨㄢㄖㄢ", // 傳染
"ㄕㄢㄉㄧㄥ", // 山頂
"ㄉㄜㄍㄨㄛ", // 得過
"ㄐㄧㄥㄕㄣ", // 精神
"ㄒㄧㄣㄊㄞ", // 心態
"ㄒㄧㄤㄕㄡ", // 享受
"ㄧㄡㄇㄧㄥ", // 有命
"ㄈㄨㄑㄧㄣ", // 父親
"ㄍㄨㄟㄖㄣ", // 貴人
"ㄌㄧㄢㄕㄥ", // 連聲
"ㄍㄨㄥㄒㄩ", // 供需
"ㄒㄧㄢㄓㄨ", // 顯著
"ㄒㄧㄠㄩㄢ", // 校園
"ㄉㄧㄒㄧㄢ", // 底線
"ㄕㄨㄒㄧㄚ", // 屬下
"ㄈㄣㄍㄨㄥ", // 分工
"ㄉㄤㄋㄧㄢ", // 當年
"ㄓㄢㄒㄧㄢ", // 展現
"ㄘㄜㄇㄧㄢ", // 側面
"ㄉㄧㄥㄍㄡ", // 訂購
"ㄉㄨㄟㄈㄤ", // 對方
"ㄕㄤㄒㄧㄣ", // 上心
"ㄗㄨㄟㄖㄣ", // 罪人
"ㄇㄛㄊㄜㄦ", // 模特兒
"ㄑㄧㄢㄌㄞ", // 前來
"ㄐㄧㄝㄨㄟ", // 結尾
"ㄇㄧㄒㄧㄣ", // 迷信
"ㄑㄧㄢㄍㄨ", // 千古
"ㄅㄨㄎㄨㄟ", // 不愧
"ㄔㄨㄥㄧㄤ", // 重陽
"ㄕㄡㄑㄩㄢ", // 授權
"ㄏㄜㄌㄧㄡ", // 合流
"ㄕㄥㄒㄧㄚ", // 剩下
"ㄖㄨㄒㄩㄝ", // 入學
"ㄅㄟㄒㄧㄣ", // 背心
"ㄕㄨㄟㄓㄠ", // 睡著
"ㄨㄟㄑㄩㄢ", // 威權
"ㄏㄨㄚㄕㄥ", // 花生
"ㄩㄢㄕㄨㄞ", // 元帥
"ㄑㄩㄥㄖㄣ", // 窮人
"ㄑㄧㄥㄌㄩ", // 情侶
"ㄒㄧㄣㄨㄟ", // 欣慰
"ㄅㄧㄢㄩㄢ", // 邊緣
"ㄋㄢㄒㄧㄥ", // 男性
"ㄊㄧㄠㄓㄥ", // 調整
"ㄑㄧㄢㄧㄕ", // 潛意識
"ㄉㄨㄟㄈㄨ", // 對付
"ㄎㄨㄞㄙㄨ", // 快速
"ㄔㄨㄤㄌㄧ", // 創立
"ㄑㄧㄣㄧㄡ", // 親友
"ㄒㄩㄝㄕㄥ", // 學生
"ㄐㄧㄐㄧㄠ", // 計較
"ㄒㄧㄥㄈㄣ", // 興奮
"ㄇㄟㄇㄧㄠ", // 美妙
"ㄇㄛㄕㄨㄟ", // 墨水
"ㄔㄤㄐㄧㄤ", // 長江
"ㄙㄨㄛㄋㄚ", // 嗩吶
"ㄧㄡㄩㄥㄔ", // 游泳池
"ㄧㄡㄒㄧㄠ", // 有效
"ㄆㄧㄥㄉㄢ", // 平淡
"ㄐㄧㄢㄕㄜ", // 建設
"ㄏㄨㄚㄊㄧ", // 話題
"ㄙㄨㄟㄩㄝ", // 歲月
"ㄅㄧㄥㄍㄡ", // 併購
"ㄓㄨㄉㄨㄛ", // 諸多
"ㄧㄣㄐㄧㄣ", // 引進
"ㄎㄨㄛㄓㄢ", // 擴展
"ㄇㄢㄏㄨㄚ", // 漫畫
"ㄅㄠㄌㄧㄡ", // 保留
"ㄓㄥㄊㄨㄥ", // 正統
"ㄐㄧㄝㄔㄨ", // 接觸
"ㄐㄧㄌㄧㄝ", // 激烈
"ㄓㄨㄥㄉㄚ", // 重大
"ㄏㄠㄒㄩㄝ", // 好學
"ㄔㄥㄗㄨㄛ", // 乘坐
"ㄎㄡㄕㄨㄟ", // 口水
"ㄍㄨㄛㄩㄢ", // 果園
"ㄇㄧㄠㄕㄨ", // 描述
"ㄒㄩㄥㄓㄤ", // 兄長
"ㄔㄨㄥㄍㄠ", // 崇高
"ㄒㄧㄥㄔㄥ", // 形成
"ㄗㄢㄊㄨㄥ", // 贊同
"ㄉㄚㄐㄩㄣ", // 大軍
"ㄉㄨㄟㄎㄤ", // 對抗
"ㄊㄤㄕㄨㄟ", // 糖水
"ㄐㄧㄝㄗㄡ", // 節奏
"ㄓㄨㄟㄓㄨ", // 追逐
"ㄐㄧㄝㄘㄥ", // 階層
"ㄓㄨㄢㄕㄣ", // 轉身
"ㄅㄤㄑㄧㄡ", // 棒球
"ㄍㄨㄤㄧㄣ", // 光陰
"ㄆㄧㄐㄧㄡ", // 啤酒
"ㄔㄨㄢㄩㄢ", // 船員
"ㄌㄨㄛㄕㄡ", // 落手
"ㄉㄧㄌㄨㄛ", // 低落
"ㄍㄨㄛㄨㄞ", // 國外
"ㄖㄨㄗㄨㄛ", // 入座
"ㄏㄜㄆㄧㄥ", // 和平
"ㄇㄧㄣㄓㄨ", // 民主
"ㄗㄠㄗㄨㄛ", // 造作
"ㄐㄧㄥㄔㄤ", // 經常
"ㄎㄜㄍㄨㄢ", // 客觀
"ㄔㄥㄋㄧㄢ", // 成年
"ㄕㄤㄐㄧㄚ", // 商家
"ㄑㄧㄢㄕㄜ", // 前設
"ㄊㄨㄟㄘㄜ", // 推測
"ㄈㄢㄉㄨㄟ", // 反對
"ㄍㄨㄥㄓㄥ", // 公正
"ㄑㄧㄥㄨㄚ", // 青蛙
"ㄌㄧㄏㄨㄢ", // 罹患
"ㄋㄧㄡㄑㄩ", // 扭曲
"ㄐㄩㄇㄧㄣ", // 居民
"ㄇㄥㄏㄨㄢ", // 夢幻
"ㄕㄥㄊㄧㄠ", // 聲調
"ㄨㄞㄏㄨㄟ", // 外匯
"ㄐㄧㄓㄨㄣ", // 基準
"ㄖㄨㄛㄈㄟ", // 若非
"ㄓㄤㄊㄧㄝ", // 張貼
"ㄔㄢㄆㄧㄣ", // 產品
"ㄇㄧㄢㄐㄩ", // 面具
"ㄏㄨㄉㄨㄥ", // 互動
"ㄒㄧㄤㄧㄥ", // 相應
"ㄈㄥㄙㄨㄛ", // 封鎖
"ㄎㄜㄒㄩㄝ", // 科學
"ㄇㄨㄙㄨㄥ", // 目送
"ㄗㄥㄙㄨㄥ", // 贈送
"ㄋㄢㄏㄞㄗ", // 男孩子
"ㄇㄧㄢㄆㄧ", // 面皮
"ㄉㄧㄥㄑㄧ", // 定期
"ㄕㄜㄏㄨㄟ", // 社會
"ㄌㄧㄡㄌㄧ", // 流利
"ㄧㄢㄌㄨㄣ", // 言論
"ㄒㄧㄤㄈㄢ", // 相反
"ㄒㄧㄣㄖㄣ", // 信任
"ㄅㄨㄓㄨㄛ", // 捕捉
"ㄉㄧㄐㄧㄢ", // 低賤
"ㄎㄠㄌㄧㄤ", // 考量
"ㄐㄧㄚㄖㄣ", // 家人
"ㄗㄨㄢㄧㄢ", // 鑽研
"ㄉㄚㄐㄧㄠ", // 打交
"ㄏㄨㄚㄓㄢ", // 畫展
"ㄈㄨㄨㄧㄝ", // 服務業
"ㄈㄚㄇㄧㄥ", // 發明
"ㄕㄡㄒㄧㄚ", // 手下
"ㄐㄧㄤㄏㄨ", // 江湖
"ㄏㄨㄟㄏㄜ", // 回合
"ㄉㄤㄕㄖㄣ", // 當事人
"ㄑㄧㄣㄕㄡ", // 親手
"ㄒㄧㄠㄩㄥ", // 效用
"ㄉㄨㄟㄕㄡ", // 對手
"ㄏㄨㄒㄧㄣ", // 互信
"ㄐㄧㄥㄒㄧ", // 精細
"ㄒㄩㄝㄓㄤ", // 學長
"ㄉㄨㄛㄇㄜ", // 多麼
"ㄇㄚㄗㄨㄟ", // 麻醉
"ㄧㄡㄕㄏㄡ", // 有時候
"ㄍㄢㄉㄨㄥ", // 感動
"ㄉㄨㄢㄓㄢ", // 短暫
"ㄊㄧㄌㄧㄤ", // 體諒
"ㄖㄣㄐㄧㄚ", // 人家
"ㄐㄧㄚㄖㄨ", // 加入
"ㄏㄨㄢㄓㄜ", // 患者
"ㄌㄧㄢㄓㄠ", // 聯招
"ㄌㄧㄌㄨㄣ", // 理論
"ㄐㄧㄑㄩㄢ", // 極權
"ㄧㄡㄧㄨㄧ", // 有意無意
"ㄊㄧㄢㄖㄢ", // 天然
"ㄑㄩㄝㄎㄡ", // 缺口
"ㄍㄨㄢㄇㄛ", // 觀摩
"ㄏㄨㄟㄧㄕ", // 會議室
"ㄕㄤㄒㄧㄚ", // 上下
"ㄖㄜㄒㄧㄣ", // 熱心
"ㄆㄛㄑㄧㄝ", // 迫切
"ㄧㄢㄎㄨㄤ", // 眼眶
"ㄋㄧㄥㄇㄥ", // 檸檬
"ㄒㄧㄊㄨㄥ", // 系統
"ㄒㄧㄣㄗㄤ", // 心臟
"ㄐㄧㄣㄙㄜ", // 金色
"ㄈㄛㄐㄧㄠ", // 佛教
"ㄨㄟㄕㄐㄧ", // 威士忌
"ㄍㄢㄎㄨㄞ", // 趕快
"ㄕㄨㄟㄍㄡ", // 水溝
"ㄐㄧㄢㄉㄢ", // 簡單
"ㄋㄩㄝㄉㄞ", // 虐待
"ㄌㄨㄉㄨㄢ", // 路段
"ㄒㄧㄣㄧㄤ", // 信仰
"ㄒㄧㄝㄓㄨ", // 協助
"ㄐㄧㄠㄍㄟ", // 交給
"ㄍㄨㄛㄖㄢ", // 果然
"ㄉㄧㄢㄧㄥ", // 電影
"ㄌㄧㄤㄆㄤ", // 兩旁
"ㄅㄧㄝㄖㄣ", // 別人
"ㄏㄣㄒㄧㄣ", // 狠心
"ㄔㄨㄉㄨㄥ", // 觸動
"ㄕㄨㄒㄧㄝ", // 書寫
"ㄩㄣㄉㄨㄥ", // 運動
"ㄌㄧㄢㄇㄥ", // 聯盟
"ㄒㄧㄣㄊㄡ", // 心頭
"ㄉㄨㄟㄓㄤ", // 隊長
"ㄏㄡㄏㄨㄟ", // 後悔
"ㄋㄟㄖㄨㄥ", // 內容
"ㄐㄧㄢㄅㄤ", // 肩膀
"ㄒㄧㄚㄓㄞ", // 狹窄
"ㄗㄨㄣㄕㄡ", // 遵守
"ㄅㄨㄒㄧㄚ", // 不下
"ㄅㄟㄉㄨㄥ", // 被動
"ㄏㄨㄛㄒㄧ", // 獲悉
"ㄐㄩㄣㄏㄥ", // 均衡
"ㄎㄜㄌㄧㄢ", // 可憐
"ㄏㄨㄛㄒㄩ", // 或許
"ㄘㄨㄥㄨㄟ", // 從未
"ㄉㄨㄥㄑㄩ", // 東區
"ㄏㄨㄟㄉㄚ", // 回答
"ㄉㄢㄒㄧㄣ", // 擔心
"ㄈㄨㄘㄨㄥ", // 服從
"ㄕㄤㄇㄧㄢ", // 上面
"ㄑㄧㄕㄨㄟ", // 汽水
"ㄎㄞㄎㄨㄛ", // 開闊
"ㄘㄨㄥㄓㄥ", // 從政
"ㄧㄅㄨㄅㄨ", // 一步步
"ㄕㄥㄏㄨㄛ", // 生活
"ㄓㄨㄧㄌㄧ", // 注意力
"ㄆㄧㄠㄈㄤ", // 票房
"ㄆㄨㄅㄧㄢ", // 普遍
"ㄘㄞㄒㄧㄥ", // 採行
"ㄕㄓㄥㄈㄨ", // 市政府
"ㄑㄧㄣㄇㄧ", // 親密
"ㄇㄚㄑㄩㄝ", // 麻雀
"ㄘㄞㄊㄨㄢ", // 財團
"ㄔㄨㄥㄐㄧ", // 衝擊
"ㄌㄨㄐㄩㄣ", // 陸軍
"ㄅㄨㄉㄨㄟ", // 部隊
"ㄌㄟㄅㄧㄝ", // 類別
"ㄖㄣㄇㄧㄣ", // 人民
"ㄋㄢㄒㄧㄚ", // 南下
"ㄅㄨㄒㄧㄤ", // 不祥
"ㄕㄤㄊㄧㄢ", // 上天
"ㄇㄧㄣㄍㄢ", // 敏感
"ㄅㄧㄥㄖㄣ", // 病人
"ㄆㄧㄓㄨㄣ", // 批准
"ㄐㄧㄝㄕㄠ", // 介紹
"ㄓㄨㄤㄉㄚ", // 壯大
"ㄍㄡㄐㄧㄝ", // 勾結
"ㄇㄨㄍㄨㄤ", // 目光
"ㄕㄨㄤㄉㄚ", // 雙打
"ㄉㄚㄊㄨㄟ", // 大腿
"ㄈㄨㄑㄧㄢ", // 膚淺
"ㄈㄚㄒㄧㄥ", // 發行
"ㄒㄩㄥㄅㄨ", // 胸部
"ㄊㄨㄥㄓㄣ", // 童真
"ㄗㄞㄗㄨㄛ", // 在座
"ㄑㄧㄤㄉㄚ", // 搶答
"ㄉㄨㄛㄕㄠ", // 多少
"ㄑㄧㄥㄔㄜ", // 清澈
"ㄏㄨㄚㄧㄤ", // 花樣
"ㄓㄨㄌㄧㄡ", // 主流
"ㄆㄟㄊㄨㄥ", // 陪同
"ㄑㄧㄤㄆㄛ", // 強迫
"ㄋㄨㄥㄉㄧ", // 農地
"ㄑㄩㄝㄅㄠ", // 確保
"ㄒㄧㄢㄔㄤ", // 現場
"ㄊㄧㄓㄨㄥ", // 體重
"ㄗㄨㄛㄧㄡ", // 左右
"ㄐㄧㄠㄊㄤ", // 教堂
"ㄐㄩㄉㄨㄛ", // 居多
"ㄖㄨㄊㄨㄥ", // 如同
"ㄅㄞㄇㄧㄥ", // 擺明
"ㄒㄧㄣㄉㄜ", // 心得
"ㄏㄜㄎㄨㄤ", // 何況
"ㄊㄨㄛㄓㄢ", // 拓展
"ㄉㄚㄗㄖㄢ", // 大自然
"ㄕㄤㄕㄨㄟ", // 上水
"ㄔㄨㄤㄏㄨ", // 窗戶
"ㄎㄨㄞㄧㄠ", // 快要
"ㄓㄨㄤㄅㄟ", // 裝備
"ㄐㄧㄠㄉㄞ", // 交代
"ㄗㄨㄛㄨㄣ", // 作文
"ㄖㄨㄐㄧㄚ", // 儒家
"ㄌㄧㄝㄖㄨ", // 列入
"ㄌㄨㄣㄨㄣ", // 論文
"ㄒㄧㄚㄔㄤ", // 下場
"ㄘㄨㄣㄗㄞ", // 存在
"ㄓㄨㄥㄕㄥ", // 終生
"ㄒㄧㄌㄧㄝ", // 系列
"ㄨㄟㄍㄨㄟ", // 違規
"ㄐㄧㄏㄨㄚ", // 計劃
"ㄅㄨㄐㄧㄡ", // 不久
"ㄊㄨㄆㄧㄢ", // 圖片
"ㄧㄕㄨㄔㄥ", // 一事無成
"ㄌㄨㄣㄊㄢ", // 論壇
"ㄒㄩㄌㄧㄝ", // 序列
"ㄉㄨㄛㄕㄨ", // 多數
"ㄔㄨㄓㄨㄥ", // 初中
"ㄏㄨㄥㄙㄜ", // 紅色
"ㄅㄣㄌㄧㄥ", // 本領
"ㄑㄧㄣㄏㄞ", // 侵害
"ㄕㄨㄣㄌㄧ", // 順利
"ㄏㄠㄐㄧㄥ", // 好景
"ㄌㄟㄊㄨㄥ", // 類同
"ㄐㄧㄚㄩㄥ", // 家用
"ㄓㄥㄐㄧㄡ", // 拯救
"ㄒㄧㄤㄅㄧ", // 相比
"ㄊㄢㄙㄨㄛ", // 探索
"ㄏㄨㄛㄗㄞ", // 火災
"ㄊㄡㄒㄧㄢ", // 頭先
"ㄊㄞㄎㄨㄥ", // 太空
"ㄒㄩㄝㄒㄧ", // 學習
"ㄍㄨㄤㄊㄡ", // 光頭
"ㄐㄧㄝㄆㄞ", // 節拍
"ㄈㄥㄐㄧㄥ", // 風景
"ㄊㄢㄐㄧㄡ", // 探究
"ㄍㄨㄢㄅㄧ", // 關閉
"ㄉㄨㄟㄘㄜ", // 對策
"ㄍㄣㄐㄧㄣ", // 跟進
"ㄔㄣㄌㄧㄝ", // 陳列
"ㄌㄞㄌㄧㄣ", // 來臨
"ㄑㄧㄢㄨㄟ", // 前衛
"ㄎㄨㄛㄗㄥ", // 擴增
"ㄉㄧㄒㄧㄚ", // 地下
"ㄐㄧㄢㄓㄨ", // 建築
"ㄘㄜㄌㄩㄝ", // 策略
"ㄊㄡㄉㄧㄥ", // 頭頂
"ㄊㄨㄥㄌㄟ", // 同類
"ㄗㄧㄨㄟㄕ", // 自以為是
"ㄕㄤㄅㄧㄢ", // 上邊
"ㄩㄝㄉㄧㄥ", // 約定
"ㄍㄨㄟㄋㄚ", // 歸納
"ㄐㄧㄠㄐㄧ", // 焦急
"ㄏㄤㄎㄨㄥ", // 航空
"ㄍㄨㄤㄙㄨ", // 光速
"ㄐㄧㄣㄕㄨ", // 金屬
"ㄑㄧㄥㄌㄞ", // 青睞
"ㄌㄧㄢㄒㄧ", // 連繫
"ㄍㄨㄢㄊㄡ", // 罐頭
"ㄙㄨㄛㄧㄡ", // 所有
"ㄍㄨㄤㄈㄢ", // 廣泛
"ㄑㄩㄢㄓㄡ", // 泉州
"ㄐㄧㄚㄙㄨ", // 加速
"ㄐㄩㄊㄨㄢ", // 劇團
"ㄍㄨㄐㄧㄣ", // 古今
"ㄋㄚㄊㄧㄢ", // 那天
"ㄊㄢㄒㄧㄥ", // 彈性
"ㄩㄥㄒㄧㄣ", // 用心
"ㄍㄨㄥㄌㄧ", // 功力
"ㄐㄧㄡㄔㄢ", // 糾纏
"ㄓㄣㄖㄨㄥ", // 陣容
"ㄒㄧㄝㄈㄚ", // 寫法
"ㄍㄨㄥㄧㄝ", // 工業
"ㄒㄧㄥㄍㄢ", // 性感
"ㄉㄤㄑㄧㄢ", // 當前
"ㄐㄧㄠㄕㄡ", // 教授
"ㄩㄝㄉㄨㄟ", // 樂隊
"ㄌㄨㄥㄊㄡ", // 龍頭
"ㄋㄞㄒㄧㄣ", // 耐心
"ㄗㄥㄐㄧㄣ", // 增進
"ㄧㄡㄔㄨㄥ", // 幼蟲
"ㄍㄨㄥㄔㄨ", // 共處
"ㄊㄨㄟㄈㄢ", // 推翻
"ㄘㄜㄌㄧㄤ", // 測量
"ㄐㄧㄣㄑㄩ", // 禁區
"ㄓㄣㄉㄨㄢ", // 診斷
"ㄌㄧㄖㄨㄣ", // 利潤
"ㄎㄨㄞㄇㄣ", // 快門
"ㄏㄨㄟㄕㄡ", // 揮手
"ㄔㄨㄛㄏㄠ", // 綽號
"ㄓㄣㄉㄧㄥ", // 鎮定
"ㄧㄢㄏㄨㄚ", // 煙花
"ㄎㄨㄛㄉㄚ", // 擴大
"ㄉㄨㄛㄎㄡ", // 多口
"ㄅㄧㄠㄧㄤ", // 表揚
"ㄍㄥㄏㄨㄢ", // 更換
"ㄑㄩㄢㄊㄡ", // 拳頭
"ㄊㄨㄢㄊㄧ", // 團體
"ㄍㄨㄥㄖㄢ", // 公然
"ㄐㄧㄠㄨㄤ", // 交往
"ㄖㄨㄥㄒㄩ", // 容許
"ㄉㄧㄒㄧㄚ", // 底下
"ㄆㄤㄒㄧㄝ", // 螃蟹
"ㄇㄧㄥㄅㄞ", // 明白
"ㄉㄥㄍㄨㄤ", // 燈光
"ㄉㄨㄥㄅㄨ", // 東部
"ㄉㄨㄥㄖㄣ", // 動人
"ㄍㄞㄋㄧㄢ", // 概念
"ㄙㄡㄒㄩㄣ", // 搜尋
"ㄐㄧㄢㄖㄣ", // 賤人
"ㄑㄧㄢㄊㄨ", // 前途
"ㄉㄧㄒㄧㄚ", // 低下
"ㄆㄨㄊㄨㄥ", // 普通
"ㄉㄧㄢㄔㄜ", // 電車
"ㄘㄠㄘㄨㄥ", // 草叢
"ㄓㄥㄊㄧㄢ", // 整天
"ㄈㄥㄎㄨㄤ", // 瘋狂
"ㄧㄡㄍㄨㄢ", // 有關
"ㄙㄨㄟㄖㄢ", // 雖然
"ㄗㄡㄉㄨㄥ", // 走動
"ㄇㄨㄎㄨㄢ", // 募款
"ㄒㄧㄚㄔㄣ", // 下沉
"ㄓㄨㄢㄊㄡ", // 轉頭
"ㄒㄩㄣㄓㄠ", // 尋找
"ㄏㄨㄤㄙㄜ", // 黃色
"ㄒㄧㄣㄏㄠ", // 信號
"ㄒㄧㄥㄖㄣ", // 行人
"ㄉㄨㄛㄅㄢ", // 多半
"ㄍㄨㄟㄈㄢ", // 規範
"ㄅㄧㄢㄍㄥ", // 變更
"ㄧㄔㄚㄋㄚ", // 一剎那
"ㄌㄨㄇㄧㄢ", // 路面
"ㄉㄞㄅㄧㄠ", // 代表
"ㄉㄧㄥㄨㄟ", // 定位
"ㄏㄡㄊㄧㄢ", // 後天
"ㄍㄨㄛㄉㄚ", // 國大
"ㄉㄨㄍㄨㄛ", // 渡過
"ㄍㄨㄢㄩㄢ", // 官員
"ㄒㄧㄣㄒㄩ", // 心虛
"ㄕㄜㄐㄧㄕ", // 設計師
"ㄕㄨㄟㄋㄧ", // 水泥
"ㄌㄧㄢㄙㄜ", // 臉色
"ㄋㄨㄥㄉㄨ", // 濃度
"ㄉㄧㄢㄈㄢ", // 典範
"ㄉㄚㄅㄧㄠ", // 達標
"ㄑㄧㄢㄖㄣ", // 前人
"ㄈㄡㄉㄧㄥ", // 否定
"ㄓㄨㄥㄍㄨ", // 中古
"ㄖㄨㄥㄋㄚ", // 容納
"ㄎㄨㄘㄨㄣ", // 庫存
"ㄧㄠㄑㄧㄥ", // 邀請
"ㄌㄨㄛㄌㄟ", // 落淚
"ㄋㄧㄥㄩㄢ", // 寧願
"ㄨㄞㄇㄧㄢ", // 外面
"ㄙㄨㄟㄏㄡ", // 隨後
"ㄖㄜㄌㄨㄛ", // 熱絡
"ㄏㄨㄣㄏㄜ", // 混合
"ㄏㄨㄚㄖㄣ", // 華人
"ㄒㄩㄥㄇㄠ", // 熊貓
"ㄓㄥㄗㄨㄥ", // 正宗
"ㄐㄩㄢㄖㄨ", // 捲入
"ㄒㄩㄥㄉㄧ", // 兄弟
"ㄌㄡㄉㄨㄥ", // 漏洞
"ㄈㄤㄅㄧㄢ", // 方便
"ㄎㄞㄒㄩㄝ", // 開學
"ㄏㄨㄢㄩㄢ", // 還原
"ㄊㄠㄗㄨㄟ", // 陶醉
"ㄎㄞㄔㄨㄤ", // 開創
"ㄍㄢㄒㄧㄤ", // 感想
"ㄇㄢㄒㄧㄥ", // 慢性
"ㄅㄧㄥㄈㄟ", // 並非
"ㄈㄢㄉㄨㄛ", // 繁多
"ㄙㄨㄢㄌㄜ", // 算了
"ㄕㄣㄐㄧㄥ", // 神經
"ㄇㄧㄢㄉㄜ", // 免得
"ㄗㄨㄟㄅㄚ", // 嘴巴
"ㄍㄨㄙㄨㄟ", // 骨髓
"ㄉㄧㄥㄉㄤ", // 叮噹
"ㄒㄧㄤㄔㄨ", // 相處
"ㄊㄧㄝㄌㄨ", // 鐵路
"ㄑㄩㄒㄧㄢ", // 曲線
"ㄍㄨㄛㄨㄤ", // 國王
"ㄕㄨㄙㄨㄛ", // 事務所
"ㄊㄧㄠㄌㄧ", // 條例
"ㄈㄚㄉㄧㄢ", // 發電
"ㄅㄞㄊㄧㄢ", // 白天
"ㄎㄨㄥㄍㄠ", // 控告
"ㄕㄡㄌㄧㄢ", // 收斂
"ㄧㄢㄏㄨㄚ", // 演化
"ㄐㄩㄒㄧㄥ", // 舉行
"ㄎㄨㄥㄑㄧ", // 空氣
"ㄙㄨㄕㄨㄛ", // 訴說
"ㄊㄞㄒㄩㄝ", // 大學
"ㄓㄨㄟㄔㄚ", // 追查
"ㄈㄤㄍㄨㄛ", // 放過
"ㄗㄞㄒㄧㄣ", // 在心
"ㄆㄠㄒㄧㄠ", // 咆哮
"ㄏㄡㄊㄨㄟ", // 後退
"ㄅㄠㄘㄨㄣ", // 保存
"ㄈㄣㄅㄧㄝ", // 分別
"ㄍㄨㄥㄈㄨ", // 工夫
"ㄧㄥㄧㄝㄜ", // 營業額
"ㄅㄢㄑㄩㄢ", // 版權
"ㄙㄨㄟㄕㄡ", // 隨手
"ㄧㄥㄆㄧㄢ", // 影片
"ㄆㄧㄥㄉㄥ", // 平等
"ㄓㄣㄉㄨㄟ", // 針對
"ㄋㄧㄢㄔㄨ", // 年初
"ㄙㄨㄟㄉㄧ", // 隨地
"ㄗㄨㄟㄏㄡ", // 最後
"ㄌㄧㄡㄌㄨ", // 流露
"ㄍㄨㄢㄎㄢ", // 觀看
"ㄔㄨㄤㄗㄠ", // 創造
"ㄏㄨㄚㄕㄨ", // 滑鼠
"ㄏㄨㄛㄕㄢ", // 火山
"ㄍㄞㄇㄧㄥ", // 改名
"ㄐㄧㄝㄇㄨ", // 節目
"ㄋㄧㄠㄌㄟ", // 鳥類
"ㄎㄠㄐㄧㄣ", // 靠近
"ㄘㄨㄣㄈㄤ", // 存放
"ㄖㄨㄐㄧㄣ", // 如今
"ㄒㄧㄣㄒㄧ", // 信息
"ㄔㄨㄥㄕㄣ", // 重申
"ㄓㄨㄔㄖㄣ", // 主持人
"ㄨㄣㄋㄨㄢ", // 溫暖
"ㄉㄚㄒㄩㄢ", // 大選
"ㄏㄨㄣㄌㄧ", // 婚禮
"ㄓㄨㄥㄌㄟ", // 種類
"ㄉㄚㄐㄧㄝ", // 打劫
"ㄉㄚㄌㄧㄤ", // 大量
"ㄘㄢㄎㄨㄟ", // 慚愧
"ㄌㄧㄢㄖㄣ", // 連任
"ㄏㄨㄥㄅㄠ", // 紅包
"ㄍㄜㄗㄒㄧ", // 歌仔戲
"ㄏㄨㄟㄌㄩ", // 匯率
"ㄆㄧㄥㄈㄢ", // 平反
"ㄓㄨㄋㄧㄢ", // 逐年
"ㄉㄧㄢㄕㄡ", // 點收
"ㄒㄧㄋㄧㄡ", // 犀牛
"ㄧㄠㄏㄨㄤ"  // 搖晃
      ]
